import React from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {closeModalAction} from '../../../../store/actions/modal.actions';
import {modalSlideIdSelector, modalVisibleSelector} from '../../../../store/selectors/modal';
import {loadedPresentationSelector} from '../../../../store/selectors/presentation.selectors';
import Modal from '../../../../ui/components/common/Modal';
import {DeviceType} from '../../../../incase-domain/common/DeviceType.enum';
import usePresScale from '../../../../util/usePresScale';
import {useSlideBackground} from '../../../../hooks/useSlideBackground';
import Slide from '../../../slide/slide';

interface SlideModalProps {
    device: DeviceType;
}

const emptySlide = {
    _id: '',
    name: '',
    slideBackground: '',
    slideMobileBackground: '',
    elements: [],
    appliedRules: [],
    width: '1360',
    height: '760',
    hidden: false,
};

export function SlideModal({device}: SlideModalProps): JSX.Element {
    const dispatch = useDispatch();
    const modalVisible = useSelector(modalVisibleSelector);
    const modalSlideId = useSelector(modalSlideIdSelector);
    const {scale, slideSize} = usePresScale();

    const isDesktop = device === DeviceType.DESKTOP;

    const loadedPresentation = useSelector(loadedPresentationSelector);
    const slide = loadedPresentation?.slides.find((s) => s._id === modalSlideId);
    const {effectiveBackgroundColor, effectiveBackgroundImage} = useSlideBackground(loadedPresentation, device, slide);

    const isMobile = device === DeviceType.MOBILE;

    const wrapperStyle: React.CSSProperties = isMobile
        ? {height: '100%'}
        : {
              backgroundColor: effectiveBackgroundColor,
              ...(effectiveBackgroundImage && {
                  backgroundImage: `url('${effectiveBackgroundImage}')`,
                  backgroundSize: '100% 100%',
              }),
              height: '100%',
              borderRadius: 'inherit',
              overflow: 'hidden',
          };

    return (
        <Modal size={isDesktop ? 'to-scale' : 'vh'} delay={500} isOpen={modalVisible} onCancel={() => dispatch(closeModalAction())}>
            {modalVisible && (
                <div
                    style={
                        isDesktop
                            ? {height: `${slideSize.height}px`, width: `${slideSize.width}px`}
                            : {
                                  height: 'calc(100vh - 140px)',
                                  width: 'calc(100vw - 32px)',
                                  backgroundColor: effectiveBackgroundColor,
                                  ...(effectiveBackgroundImage && {
                                      backgroundImage: `url('${effectiveBackgroundImage}')`,
                                      backgroundSize: '100% 100%',
                                  }),
                              }
                    }
                >
                    <div
                        id="modal-slide-holder"
                        className={isDesktop ? undefined : 'u-p-1'}
                        style={isDesktop ? {fontSize: `${scale * 16}px`} : {overflowY: 'auto'}}
                    >
                        <div style={wrapperStyle}>
                            <Slide slide={slide || emptySlide} device={device} />
                        </div>
                    </div>
                </div>
            )}
        </Modal>
    );
}
